import React, {Component} from "react";
import moment from "moment";
import haversineInYards from "../../../utils/haversine";
import ImageThumbnail from "../../imgs/thumbnail";
import {EventTypeLabelMap, legendClassMapping} from "../../screens/TrackerMap3";

class TimelineListItem extends Component {
    constructor(props) {
        super(props);

        this.distance = this._getDistanceFromLocation();
        this.timeDiff = this._getDifferenceBetweenPhoneAndSendTime();

        this.geoLocationAlertSensitivity =
            props.data.event_type === "door_canvass" ? 60 : 180;
    }

    _generateSubData = () => {
        let target_name = this.props.target ? this.props.target.name : "";
        switch (this.props.data.event_type) {
            case "check_in":
            case "check_out":
                return <div className="obj-data">{target_name}</div>;

            case "log_response":
                let res = [];
                if (this.props.data.door_address) {
                    res.push(
                        <div className="obj-data" key={`subdoor-${JSON.stringify(this.props.data.door_address)}`} style={{fontWeight: "Bold"}}>
                            {this.props.data.door_address}
                        </div>
                    );
                }
                if (!this.props.data.responses || !this.props.data.responses.length) {
                    res.push(<div key={`noresponsesfor-${this.props.data.id}`} className="obj-data">Responses were not found.</div>)
                } else {
                    this.props.data.responses
//                        .sort((a, b) => (a.media_src ? -1 : a.id > b.id ? 1 : -1))
                        .forEach((d) => {
                            res.push(
                                <div className="obj-data" key={`sub-${JSON.stringify(d)}`}>
                                    {d.media_src ? (
                                        <ImageThumbnail
                                            src={d.media_thumb_src || d.media_src}
                                            largeSrc={d.media_src}
                                        />
                                    ) : (
                                        <div>{d.response}</div>
                                    )}
                                </div>
                            );
                        });
                    return res;
                }

            case "door_canvass":
                const primary = this.props.data.primary_phone;
                const secondary = this.props.data.secondary_phone;
                const primaryText = primary ? `Phone 1: ${primary}` : "";
                const secondaryText = secondary ? `Phone 2: ${secondary}` : "";

                return (
                    <>
                        <div className="obj-data" key={`subdoorcanvass-${JSON.stringify(this.props.data.door_address)}`} style={{fontWeight: "Bold"}}>
                            {this.props.data.door_address}
                        </div>
                        <div className="obj-data">
                            {(this.props.data.status || "").replace("_", " ")}
                        </div>
                        {primary && <div className="obj-data">{primaryText} </div>}
                        {secondary && <div className="obj-data">{secondaryText} </div>}
                    </>
                );

            case "training_start":
            case "training_end":
                return (
                    <>
                        <div className="obj-data" style={{fontWeight: "Bold"}}>
                            {!!this.props.data?.ex_info?.trainee_name && "Trainee:"}{" "}
                            {this.props.data?.ex_info?.trainee_name}
                        </div>
                    </>
                );

            case "log_in":
            case "log_out":
            default:
                return <div/>;
        }
    };

    _getDistanceFromLocation = () => {
        let {data} = this.props;

        let tlat, tlon;
        if (this.props.target) {
            tlat = this.props.target.lat;
            tlon = this.props.target.lon;
        }

        if (!tlat || !tlon) return 0;

        let distance = haversineInYards(data.latitude, data.longitude, tlat, tlon);
        return Math.floor(distance);
    };

    _getDifferenceBetweenPhoneAndSendTime = () => {
        let {event_time, created_at} = this.props.data;

        let diff = moment.duration(moment(event_time).diff(moment(created_at)));
        let milliseconds = diff._milliseconds || 0;
        if (milliseconds / (60 * 60 * 1000) > 1) {
            // console.log("diff is true", milliseconds / (60 * 60 * 1000));
            return diff;
        } else {
            return false;
        }
    };

    _buildTimeDiffWarning = () => {
        if (!this.timeDiff) return <></>;

        return (
            <div className={"obj-data"} style={{color: "red"}}>
                <i className="far fa-clock"/> Packet is{" "}
                {this.timeDiff.days() ? `${this.timeDiff.days()} days, ` : ""}
                {this.timeDiff.hours() ? `${this.timeDiff.hours()} hrs, ` : ""}
                {this.timeDiff.minutes() ? `${this.timeDiff.minutes()} min ` : ""}
                late
            </div>
        );
    };

    render() {
        let {data, focused} = this.props;

        return (
            <div
                id={`event-action-${data.id}`}
                className={`side-menu-list-obj ${focused && "focused"}`}
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
                onClick={this.props.onTitleClick}
            >
                {/*inner wrapper to generate side color border*/}
                <div
                    className="list-obj-inner-wrapper"
                    style={{borderLeftColor: legendClassMapping[data.event_type] || 'black'}}
                >
                    <div className="obj-title" onClick={this.props.onTitleClick}>
                        {EventTypeLabelMap[data.event_type] || data.event_type.replace("_", " ")}
                    </div>
                    {this._generateSubData()}
                    {this.props.canvasser && <div className="obj-data">
                        {this.props.canvasser.canvasser_name}
                    </div>}
                    <div className="obj-data">
                        {moment(data.phone_time).format("LT")}
                    </div>

                    {this.distance > this.geoLocationAlertSensitivity ?
                        <div className={"obj-data"} style={{color: "red"}}>
                            <i className="fas fa-exclamation-triangle"></i> {this.distance}{" "}
                            Yards from {this.props.target.name}
                            {data.loc_accuracy
                                ? `(±${Math.round(data.loc_accuracy * 1.093613)})`
                                : ""}
                        </div>
                        : (this.props.target) ?
                            <div className="obj-data">
            <span
                className={"fa fa-building"}
                style={{fontSize: 10, marginRight: 4}}
            />
                                {this.props.target.name}
                            </div>
                            : null
                    }

                    {this._buildTimeDiffWarning()}

                    {(!data.longitude || !data.latitude) && (
                        <div className={"obj-data"} style={{color: "red"}}>
                            <i className="fas fa-exclamation-triangle"></i> Bad Location Update
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default TimelineListItem;
